import Image from "next/image";
import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { TLink } from "@/components/molecules/Button";
import { useBudouX } from "@/hooks/useBudouX";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Contact from "@/components/organisms/Contact";
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { VoiceCover } from "@/components/organisms/VoiceCover";
import { VoiceNav } from "@/components/organisms/VoiceNav";
import voicePhoto from "/public/voice-photo2.webp";
import voicePhotoB from "/public/voice-photo2b.webp";

export default function CareerArticle2(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "Voices:メンバーの声 No.2 育児休暇を取得しやすい社内の人間関係のある環境"
        }
        pageDescription={
          "株式会社トッカシステムズのVoices:メンバーの声 No.2 育児休暇を取得しやすい社内の人間関係のある環境。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/careers/voice/2"}
      />
      <Layout className="relative">
        <div className="absolute z-0 aspect-1/1 w-full bg-voices-no2 xs:max-h-[300px] sm:max-h-[300px] md:aspect-1/1 md:max-h-[500px] lg:max-h-[640px]"></div>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Careers",
                  path: "/",
                },
                {
                  name: "Voices:メンバーの声 No.2",
                },
              ]}
            />
            <Inner className="max-w-full">
              <div className="mx-auto flex max-w-6xl flex-col">
                <VoiceCover
                  title="育児休暇を取得しやすい社内の人間関係のある環境"
                  avatar="K.Wさん - 2015年入社"
                />
                <figure className="relative mt-6 block aspect-2/1 w-full group-hover:opacity-80 md:mt-8 lg:mt-10">
                  <Image
                    src={voicePhoto}
                    alt="育児休暇を取得しやすい社内の人間関係のある環境 K.Wさん - 2015年入社"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </figure>
              </div>
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>K.Wさんの入社されたのは?</Interviewer>
                <Interviewee>
                  ToccaSystemsは4社目です。前職では、採用人事担当をしていたり、電話対応コンクールの全国大会で賞を頂いたこともあります。
                </Interviewee>
                <Interviewer>
                  ToccaSystemsに入社した時の印象を教えてください。
                </Interviewer>
                <Interviewee>
                  口調のきつい方がいない！穏やかな人ばかりだな、と正直驚きました。
                </Interviewee>
                <Interviewer>
                  ToccaSystemsの好きなところはどこですか？
                </Interviewer>
                <Interviewee>
                  私はToccaSystemsに入社してから、育児休暇を2度取得しました。妊娠中、冬の雪が降る中、道路で車から雪をかけられて濡れた状態で出社したことがあるんですけど…。技術部の方達が、ホッカイロをくれたんです。大丈夫ですか？お腹冷やさないでください、って。嬉しかったですよ。しばらく使えませんでした（笑）みんな優しいんです。出産する前は、就業後に社内の仲間と週3で飲みに行ってました（笑）楽しかったなぁ。
                </Interviewee>
                <div className="relative aspect-1.91/1">
                  <Image
                    src={voicePhotoB}
                    alt="【Voices: メンバーの声 No.2】 インタビューカット"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>
                  良い人が多いと皆さんから聞きますが、なぜでしょうか？
                </Interviewer>
                <Interviewee>
                  代表取締役の谷と取締役の吉田の二人は、性格が真逆なんです。だからバランスが良いのかもしれません。あと距離感が近いんです。
                </Interviewee>
                <Interviewer>
                  業務をする上で、心がけていることってありますか？
                </Interviewer>
                <Interviewee>
                  そうですね…総務部って会社の支えだと思うんです。だから会社の役に立つことは、なんでも前向きに全部やるぞ、と。総務部のバックオフィス業務は、技術職に比べて技術力が上がるとか、目に見える自分の成長だったり、クライアントが喜んだ顔は見えにくいんですけど、「この会社に入って良かった！」と社内からの声を聞くと、「やったー！」と思っています。
                </Interviewee>
                <Interviewer>
                  最後に、一緒に働いてみたいと思う人を教えてください。
                </Interviewer>
                <Interviewee>
                  自分でがんばることができる人と働きたいです。教えてもらったことはしっかり覚えて、次は自分で挑戦してみる、自立心があるそんな人が良いですね。
                </Interviewee>
                <div className="flex justify-end px-8 md:px-0">
                  <TLink href="/careers/" variant="mono" color="ff">
                    Carrers top
                  </TLink>
                </div>
              </div>
              <VoiceNav />
            </Inner>
          </Container>
        </main>
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
